import React, { useEffect, useRef } from 'react';
import styles from './TableHeader.module.sass';

const TableHeader = ({
    children, scrollLeft
}: Props) => {
    const ref = useRef<any>(null);
    
    useEffect(() => {
        if (!ref?.current) return;
        ref.current.scrollLeft = scrollLeft;
    }, [scrollLeft]);

    return <div
        className={styles['tableheader']}
        ref={ref}
    >
        { children }
    </div>;
}

interface Props {
    children?: any
    scrollLeft?: any
}

export default TableHeader;